var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIdm = function SvgIdm(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50986 3.5V20.5H1.375V3.5H5.50986Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 11.9639C22.625 13.6311 22.2623 15.1139 21.5369 16.4123C20.8276 17.6947 19.7959 18.6966 18.4418 19.418C17.1038 20.1393 15.524 20.5 13.7024 20.5H7.24624V3.5H13.7024C15.5401 3.5 17.128 3.85266 18.466 4.55799C19.8039 5.26332 20.8276 6.25719 21.5369 7.5396C22.2623 8.82202 22.625 10.2968 22.625 11.9639ZM13.3397 16.8211C14.9517 16.8211 16.2011 16.3963 17.0877 15.5467C17.9904 14.6971 18.4418 13.5028 18.4418 11.9639C18.4418 10.425 17.9904 9.23079 17.0877 8.38119C16.2011 7.53159 14.9517 7.10679 13.3397 7.10679H11.3811V16.8211H13.3397Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIdm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "idm.b9aa899ccb3e3b6e59a9cfe0f64b8e4a.svg";